import { render, staticRenderFns } from "./AnswerProp.vue?vue&type=template&id=71aa2258&scoped=true&"
import script from "./AnswerProp.vue?vue&type=script&lang=js&"
export * from "./AnswerProp.vue?vue&type=script&lang=js&"
import style0 from "./AnswerProp.vue?vue&type=style&index=0&id=71aa2258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa2258",
  null
  
)

export default component.exports